module.exports = __webpack_public_path__ + "img/icon_banner.37fee5db.png";